import { endOfMonth, format, getMonth } from "date-fns";

// JS months starts at index 0.. so january is 0, december is 11
const MONTH_JANUARY = 0;
const MONTH_JULY = 6;
const MONTH_AUGUST = 7;
const MONTH_SEPTEMBER = 8;

const getEndOfPolicyPeriod = (year: number, manulifesv = false) => endOfMonth(new Date(year, manulifesv ? MONTH_JANUARY : MONTH_AUGUST, 1));

const isDateLessThan29ofJan = (month: number, date: number) => month === MONTH_JANUARY && date < 29;

export const formatDate = (date: Date) => format(date, "MMMM d yyyy");

const getNextYearEndDate = (currentYear: number) => getEndOfPolicyPeriod(currentYear + 1, true);

const getCurrentYearEndDate = (currentYear: number) => getEndOfPolicyPeriod(currentYear, true);

const shouldAdjustStartDateFor2026 = (currentYear: number, month: number, date: number) => currentYear === 2026 && isDateLessThan29ofJan(month, date);

const shouldUseCurrentYearEndDate = (currentYear: number, month: number) => currentYear !== 2026 && month === MONTH_JANUARY;

const adjustStartDateTo29th = (startDate: Date) => {
  startDate.setDate(29);
};

const manulifeSVDateRange = (finalData: { startDate: Date; endDate: Date }, month: number, currentYear: number) => {
  finalData.endDate = getNextYearEndDate(currentYear);
  if (shouldAdjustStartDateFor2026(currentYear, month, finalData.startDate.getDate())) {
    adjustStartDateTo29th(finalData.startDate);
  }
  if (shouldUseCurrentYearEndDate(currentYear, month)) {
    finalData.endDate = getCurrentYearEndDate(currentYear);
  }
  return finalData;
};

const createSeptemberStartDate = (currentYear: number) => ({
  startDate: new Date(currentYear, MONTH_SEPTEMBER, 1),
  endDate: getEndOfPolicyPeriod(currentYear + 1),
});

const createCurrentDateRange = (currentYear: number) => ({
  startDate: new Date(),
  endDate: getEndOfPolicyPeriod(currentYear + 1),
});

const isJulyOrAugust = (month: number) => [MONTH_JULY, MONTH_AUGUST].includes(month);

const isAfterAugust = (month: number) => month > MONTH_AUGUST;

const manulifeNonSVDateRange = (finalData: { startDate: Date; endDate: Date }, month: number, currentYear: number) => {
  let dateRange = { ...finalData };
  if (isJulyOrAugust(month)) {
    dateRange = createSeptemberStartDate(currentYear);
  }
  if (isAfterAugust(month)) {
    dateRange = createCurrentDateRange(currentYear);
  }
  return dateRange;
};
const getStartAndEndDate = (month: number, currentYear: number, manulifesv: boolean) => {
  const finalData = {
    startDate: new Date(),
    endDate: getEndOfPolicyPeriod(currentYear, manulifesv),
  };
  return manulifesv ? manulifeSVDateRange(finalData, month, currentYear) : manulifeNonSVDateRange(finalData, month, currentYear);
};

export const getCurrentPolicyPeriod = (manulifesv = false) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  return getStartAndEndDate(getMonth(currentDate), currentYear, manulifesv);
};

export const getRenewalPolicyPeriod = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  return { startDate: new Date(currentYear, MONTH_SEPTEMBER, 1), endDate: getEndOfPolicyPeriod(currentYear + 1) };
};
